<template>
  <span>
    <button @click="showModal = true">
      <i id="player-play" class="fa fa-5x fa-share" style="font-size: 22px !important"></i>
    </button>

    <b-modal title="Share Shiurim" v-model="showModal" hide-footer centered size="md">
      <div class="d-flex justify-content-around">
        <button v-for="(share, index) in shares" class="btn btn-outline-light">
          <ShareNetwork :key="index" :network="share.network" :url="url" :title="title" :description="description" :hashtags="hashtags">
            <span><i :class="'fa mr-2 fa-' + share.network"></i>{{ share.network.toUpperCase() }}</span>
          </ShareNetwork>
        </button>
        <button class="btn btn-outline-light">
          <a target="_blank" :href="'mailto:?subject=' + emailContent.title + '&body=' + emailContent.body">
            <span><i class="fa mr-2 fa-envelope"></i>EMAIL</span>
          </a>
        </button>
      </div>
    </b-modal>
  </span>
</template>

<script>
import VueSocialSharing from 'vue-social-sharing';
import Vue from 'vue';
export default {
  props: ['url', 'title', 'description', 'hashtags'],
  components: {
    VueSocialSharing,
  },
  computed: {
    emailContent() {
      return {
        title: 'Watch this shiur on Shasilluminated',
        body: this.title + '%0D%0A' + this.url,
      };
    },
  },
  data() {
    return {
      showModal: false,
      shares: [{ network: 'facebook' }, { network: 'twitter' }, { network: 'whatsapp' }],
    };
  },
  created() {
    Vue.use(VueSocialSharing);
    console.log(this.title);
  },
};
</script>

<style>
.share-btn {
}
</style>